import auth from './en-US/auth';
import button from './en-US/button';
import error from './en-US/error';
import errorCode from './en-US/errorCode';
import global from './en-US/global';

export default {
  ...auth,
  ...button,
  ...error,
  ...errorCode,
  ...global,
};
